import { render } from "./InvEstmenttime.vue?vue&type=template&id=f6225a12"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/InvEstmenttime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6225a12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6225a12', __exports__)) {
    api.reload('f6225a12', __exports__)
  }
  
  module.hot.accept("./InvEstmenttime.vue?vue&type=template&id=f6225a12", () => {
    api.rerender('f6225a12', render)
  })

}


export default __exports__